import React, { FC } from 'react'

import { IconDataProps } from './IconData.types'
import * as Styled from './styles/IconData.style'

import { nonThemeableRules } from '../../ruleSet'

const IconData: FC<IconDataProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDataProps['size'],
  isResponsive = false,
}: IconDataProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.873 29.118H10.75a1.546 1.546 0 0 1-1.542-1.545v-10.12a1.542 1.542 0 0 0-1.543-1.543H6.463a1.545 1.545 0 0 1-1.07-2.66l7.71-7.432c1.854-1.568 3.615-.878 4.56-.098l7.632 7.53a1.542 1.542 0 0 1-1.068 2.658H23.02a1.542 1.542 0 0 0-1.543 1.542v10.12a1.545 1.545 0 0 1-1.544 1.545l-5.06.003Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M32.347 19.07h-4.042a1.515 1.515 0 0 0-1.515 1.517v9.938a1.517 1.517 0 0 1-1.517 1.515H24.09a1.519 1.519 0 0 0-1.05 2.61l7.57 7.297c1.82 1.543 3.547.863 4.477.098l7.5-7.395a1.517 1.517 0 0 0-1.05-2.61h-1.184a1.515 1.515 0 0 1-1.516-1.515V19.07h-6.49Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconData
